import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useSetting } from '../use-cases/get-setting';
import { SettingTabel } from '../components/setting/setting';
import { CreateSettingDTO } from '../api/cms-api.service';
export const SettingView = () => {
    const { mutate, isLoading, } = useSetting();
    const [data, setData] = useState<any[]>([]);
    useEffect(() => {
        const payload: CreateSettingDTO = {
            flag: "getsetting",
            id: null,
        };

        mutate(payload, {
            onSuccess: (res: any) => {
                setData(res?.tabsSettings || []);
            },
        });
    }, []);

    return (
        <>
            <SettingTabel
                data={data}
                isLoading={isLoading}
            />

            <Outlet />
        </>
    );
};


